import React from 'react';
import { connect } from 'react-redux';

import DefaultHeader from './DefaultHeader.tsx';

class Header extends React.Component {
    render() {
        const { clientConfig } = this.props;

        return (
            <header>
                <DefaultHeader clientConfigData={clientConfig} />
            </header>
        );
    }
}

function mapStateToProps(state) {
    return {
        clientConfig: state.app.clientConfig,
    };
}

export default connect(mapStateToProps)(Header);
